"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _attribute = _interopRequireDefault(require("./attribute"));
var _element = _interopRequireDefault(require("./element"));
var _widget = _interopRequireDefault(require("./widget"));
var _set_attribute = _interopRequireDefault(require("./set_attribute"));
/*
 * @Author: qinuoyun
 * @Date:   2020-08-31 15:42:11
 * @Last Modified by:   qinuoyun
 * @Last Modified time: 2021-02-11 22:12:16
 */
var _default = {
  attribute: _attribute.default,
  element: _element.default,
  widget: _widget.default,
  set_attribute: _set_attribute.default
};
exports.default = _default;